module.exports = __webpack_public_path__ + "static/media/8.d520ed97.jpg";